// Will not mutate input array
const moveItemToBackOfArray = <T,>(array: Array<T>, index: number) => [
  ...array.slice(0, index),
  ...array.slice(index + 1),
  array[index],
];

export { moveItemToBackOfArray };
